/* Media Mic page-scoped styles (replaces external custom.css + style-app.css) */

.page-mediamic #content text,
.page-mediamic text {
    font: 21px sans-serif;
    fill: #000;
    pointer-events: none;
}

.page-mediamic #content circle,
.page-mediamic circle {
    cursor: pointer;
}

.page-mediamic .tooltip,
body > .tooltip {
    position: absolute;
    text-align: center;
    width: auto;
    height: auto;
    padding: 10px;
    font: 14px sans-serif;
    background: #ddd;
    border: 1px #aaa solid;
    border-radius: 5px;
    pointer-events: none;
}

.page-mediamic #publications {
    font-size: 12pt;
}

.page-mediamic .node:hover {
    cursor: pointer;
}

.page-mediamic .node.hidden {
    display: none;
}
